const PREFIX = "/reducres/cryAnalyser/";

export const SET_CRY_ANALYSER_RESULTS = `${PREFIX}SET_CRY_ANALYSER_RESULTS`;
export const IS_LOADING = `${PREFIX}IS_LOADING`;
